import { SearchQueryOrderDirection } from "types/generated";

export const ITEMS_LIMIT = 50;

export const FILTERS_ORDER_SETTINGS_KEY = "workerPoolsFiltersOrder";

export enum SortableColumns {
  NAME = "name",
  SPACE = "space",
  WORKERS = "workersCount",
  BUSY = "busyWorkers",
  QUEUE = "schedulableRunsCount",
}

export const INITIAL_SORT_OPTION = SortableColumns.NAME;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;

export const PRIVATE_WORKER_POOL_CALLOUT_STORAGE_KEY = "privateWorkerPoolCallout";

export const VIRTUALIZATION_THRESHOLD = 50;
